import {  Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UpdateBusinessInfoService } from 'src/app/dashboard/admin/action/components/crm/profile/services/update-business-info.service';
import { ACTIVATION_STEPS } from 'src/app/shared/activationSteps';
import { ActivationStepsService } from 'src/app/shared/services/activation-steps.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { GetBusinessProfileService } from 'src/app/shared/services/get-business-profile.service';
import { ActivationStatusSubmittedNotifier } from './activationsSubmittedNotifier.service';
import { UpdateActivationStatusService } from 'src/app/shared/services/update-activation-status.service';
import { GetActivationRequestService } from '../credit-card-request-form/get-activation-request.service';
import { BusinessInformationComponent } from './business-information/business-information.component';
import { BusinessLegalInformationComponent } from './business-legal-information/business-legal-information.component';
import { ContactInformationComponent } from './contact-information/contact-information.component';
import { LanguageService } from 'src/app/shared/services/language.service';
import { WithdrawalStatusService } from 'src/app/shared/services/withdrawal-status.service';
import { GetActivationStepService } from 'src/app/shared/services/get-activation-step.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CCUpdateStatusService } from '../../services/cc-update-status.service';
import { CCSaveBusinessDataService } from '../../services/ccsave-business-data.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-new-activation-page',
  templateUrl: './new-activation-page.component.html',
  styleUrls: ['./new-activation-page.component.scss'],
})
export class NewActivationPageComponent implements OnInit {
  @ViewChild(BusinessInformationComponent)
  BusinessInfoComp: BusinessInformationComponent;
  @ViewChild(ContactInformationComponent)
  businessContactComp: ContactInformationComponent;
  @ViewChild(BusinessLegalInformationComponent)
  businessLegalInfoComp: BusinessLegalInformationComponent;
  businessInfoOldvalues: BusinessInfoResult;
  contactInfoOldValues:Partial<ContactFormResult>;
  businessLegalInfoOldValues:any;
  BusinessInfoValid: boolean = false;;
  businessContactValid: boolean = false
  businessLegalValid : boolean =false
  isDown=false;
  lang:string;
  businessStatus:string;
  withdrawalStatus: string = '';
   constructor(
    public UpdateActivationStatus: UpdateActivationStatusService,
    public ActivationSteps: ActivationStepsService,
    private snackBar: MatSnackBar,
    private auth: AuthService,
    private update: UpdateBusinessInfoService,
    private getBusinessProfile: GetBusinessProfileService,
    private getActivationRequest: GetActivationRequestService,
    private activationSubmittedNotifier:ActivationStatusSubmittedNotifier,
    private translate: TranslateService,
    private languageService:LanguageService,
    private withdrawalStatusService: WithdrawalStatusService,
    private getActivationStepService: GetActivationStepService,
    private updateActivationReqStatus: CCUpdateStatusService,
    private saveActivationRequestData: CCSaveBusinessDataService,
    private activatedRoute: ActivatedRoute
  ) {

  }

  async ngOnInit() {
    await this.resolveWithdrawalStatus();
    this.translate.use(localStorage.getItem('language'));
    this.lang=this.translate.currentLang;
    this.languageService.languageUpdated.subscribe((lang) => {
      this.translate.use(lang);
      this.lang=lang;
    });
    this.activationSubmittedNotifier.getStatusNotification().subscribe(async(res)=>{
      const { status } = await this.withdrawalStatusService.make();
        this.withdrawalStatus = status;
    });
    this.initValues().then(async ()=>{
      this.BusinessInfoComp.initFormValues(this.businessInfoOldvalues);
      await this.businessContactComp.initFormValues(this.contactInfoOldValues);
      this.businessLegalInfoComp.initFormValues(this.businessLegalInfoOldValues)
    });
    if(this.activatedRoute.snapshot.routeConfig.path == 'business'){
      this.isDown = true //show form if user opened component from popup
    }
    this.checkValidation()
  }
  async initValues(){
    const businessProfileValues = await this.getBusinessProfile.make();
    const businessResponse = businessProfileValues.Business;
    this.getActivationRequest.setParams({
      businessId: businessResponse.id,
    });
    const requestResult = await this.getActivationRequest.make();
    const requestResultResponse=requestResult.request;
   this.contactInfoOldValues={instagram:requestResultResponse?.instagram || '' }
    this.businessInfoOldvalues = {
      CategoryId: businessResponse.CategoryId ||null,
      averagePrice: requestResultResponse?.averagePrice || null,
      logo: businessResponse.logo ||null,
      customersFromEgypt: requestResultResponse?.customersFromEgypt ||null,
      description: businessResponse.description || null,
      name: businessResponse.name ||null,
      productsDescription: requestResultResponse?.productsDescription ||null,
    };
    this.businessLegalInfoOldValues = {
      hasRegisteredBusiness : requestResultResponse?.hasRegisteredBusiness ,
      taxCard : requestResultResponse?.taxCard ?? '',
      commercialRegister : requestResultResponse?.commercialRegister?? '',
      personalIdFront : requestResultResponse?.personalIdFront ?? '',
      personalIdBack : requestResultResponse?.personalIdBack ?? ''
    }
  }
  checkValidation(){
    this.businessContactValid =this.businessContactComp.isComponentValid() ? true : false;
    this.BusinessInfoValid = this.BusinessInfoComp.isComponentValid()  ? true : false
    this.businessLegalValid = this.businessLegalInfoComp.isComponentValid() ? true : false;
  }
  businessInfoStep(){
    let collapseOne = document.getElementById('collapseOne');
    let collapseTwo = document.getElementById('collapseTwo');
    let contactInfobtn =document.getElementById('contactInfobtn')
    let businessInfobtn = document.getElementById('businessInfobtn')

    if( this.businessContactComp.isComponentValid() ){
      collapseOne.classList.remove('show')
      contactInfobtn.classList.add('collapsed')
     collapseTwo.classList.add('show')
     businessInfobtn.classList.remove('collapsed')
     this.businessContactValid = true
     this.BusinessInfoValid = true
     this.resolveUpdateInfo();
    }else{
      this.resolveErrors();
   }

  }
  LegalInfoStep(){
    let collapseTwo = document.getElementById('collapseTwo');
    let collapseThree= document.getElementById('collapseThree');
    let businessInfobtn = document.getElementById('businessInfobtn')
    let legalInfobtn = document.getElementById('legalInfobtn')

    if( this.BusinessInfoComp.isComponentValid() ){
      collapseTwo.classList.remove('show')
      businessInfobtn.classList.add('collapsed')
      collapseThree.classList.add('show')
      legalInfobtn.classList.remove('collapsed')
      this.BusinessInfoValid = true
      this.businessLegalValid = true
      this.resolveUpdateInfo();
    }
    else{
       this.resolveErrors();
    }
  }
  async onSubmit() {
    try {
      if (
        this.BusinessInfoComp.isComponentValid() &&
        this.businessContactComp.isComponentValid() &&
        this.businessLegalInfoComp.isComponentValid()
      ) {
        await this.resolveUpdateInfo();
        this.activationSubmittedNotifier.pushStatusNotification();

      } else {
        await this.resolveErrors();
      }
    } catch (errors) {
      this.updateActivationReqStatus.setParams({ status: 'INCOMPLETE' })
      await this.updateActivationReqStatus.make()
      if(errors.validationErrors){
        this.BusinessInfoComp.showFormErrors(errors);
        this.businessContactComp.showFormErrors(errors);
        this.businessLegalInfoComp.showFormErrors(errors);
      } else {
        this.snackBar.open(
          this.translate.instant('Sellers.Products.ErrorDuringUpload'),
          '',
          {
            duration: 5000,
          }
        );
      }
      console.log(errors);
    }
  }

  async uploadExistData() {
    const businessFormResult: BusinessInfoResult =
      await this.BusinessInfoComp.onSubmit();
    const contactFormResult: ContactFormResult =
      await this.businessContactComp.OnFormSubmit();
    this.saveActivationRequestData.setParams({
      ...businessFormResult,
      ...contactFormResult,
    });
    await this.saveActivationRequestData.make();
    if(this.withdrawalStatus != 'pending'){
      this.updateActivationReqStatus.setParams({ status: 'INCOMPLETE' })
      await this.updateActivationReqStatus.make()
    }
  }

  async resolveUpdateInfo() {
    const businessFormResult: BusinessInfoResult =
      await this.BusinessInfoComp.onSubmit();
    const contactFormResult: ContactFormResult =
      await this.businessContactComp.OnFormSubmit();
    const {
      customersFromEgypt,
      productsDescription,
      averagePrice,
      website,
      instagram,
      ...businessInfo
    } = { ...businessFormResult, ...contactFormResult };
    this.saveActivationRequestData.setParams({
      ...businessFormResult,
      ...contactFormResult,
    });

    this.update.setParams(businessInfo);
    await this.update.make();
    await this.updateBusinessProfileActivationRequest();
    this.businessLegalInfoComp.businessActivationData = {
      customersFromEgypt,
      productsDescription,
      averagePrice,
      website,
      facebook: contactFormResult.link_fb,
      instagram,
    };
    await this.businessLegalInfoComp.onSubmit();
    await this.saveActivationRequestData.make();
  }
  resolveErrors() {
    try {
      if (!this.BusinessInfoComp.isComponentValid()) {
        this.BusinessInfoComp.showComponentErrors();
      } else if (!this.businessContactComp.isComponentValid()) {
        this.businessContactComp.showComponentErors();
      } else if (!this.businessLegalInfoComp.isComponentValid()) {
        this.businessLegalInfoComp.showComponentErrors();
      }
    } catch (err) {
      console.log(err);
    }
  }
  async updateBusinessProfileActivationRequest() {
    this.auth.setStatus('active');
    let params = {
      activationStep: ACTIVATION_STEPS.BUSINESS_PROFILE,
      activationStatus: true,
    };
    this.UpdateActivationStatus.setParams(params);
    let result = await this.UpdateActivationStatus.make();
    if (result.success) {
      this.ActivationSteps.setBusinessProfileStep = params;
    }
  }
  toggleActivationStep(){
    this.isDown=!this.isDown;
  }
  async resolveWithdrawalStatus(){
    let isOwner: boolean = await this.auth.isOwner()
    let business: any = await this.auth.getBusiness();
    if (business) {
      this.getActivationStepService.setParams({});
      let activationSteps = await this.getActivationStepService.make();
      this.ActivationSteps.setActivationSteps(activationSteps.data);
    }
    if (!!isOwner && !!business) {
      const { status } = await this.withdrawalStatusService.make();
      this.withdrawalStatus = status;
      if (this.withdrawalStatus == "done" && !this.ActivationSteps.getWithdrawalActivationStep) {
        let params = {
          activationStep: ACTIVATION_STEPS.WITHDRAWAL_ACTIVATION,
          activationStatus: true
        };

        this.UpdateActivationStatus.setParams(params);
        let result = await this.UpdateActivationStatus.make();
        if (result.success) {
          this.ActivationSteps.setWithdrawalActivationStep = params;
        }
      }
    }
  }

}

export interface BusinessInfoResult {
  CategoryId: string;
  businessLogo?: string;
  customersFromEgypt: string;
  description: string;
  logo: string;
  name: string;
  productsDescription: string;
  averagePrice: string;
}
export interface ContactFormResult {
  cs_email: string;
  cs_phone: string;
  email: string;
  link_fb: string;
  link_li: string;
  instagram: string;
  phone: string;
  website: string;
}

interface BusinessData {
  name: string;
  CategoryId: string;
  logo: string;
  cs_email: string;
  cs_phone: string;
  link_fb: string;
  link_li: string;
  description: string;
}
export interface BusinessActivationData {
  customersFromEgypt: string;
  productsDescription: string;
  averagePrice: string;
  website: string;
  facebook: string;
  instagram:string;
}
